import React, { Component } from 'react';
import { merge, contains } from 'ramda';
import { TENANT_VIEWS } from './tenantPages';
import SearchInput from '../SearchInput';
import Table from '../Table';
import Pager from '../Pager';
import TenantSources from '../../sources/tenant';
import { bindMethods } from '../../utils/core';

const subtenantColumns = [
    { 
        propertyName: 'developerName',
        renderHeader: () => 'Name',
    },
    { 
        propertyName: 'developerSummary',
        renderHeader: () => 'Summary',
    },
];

class SubtenantList extends Component {

    state = {
        subtenants: [],
        paging: {
            page: 1,
            pageSize: 20,
            total: 0,
        },
        query: '',
    };

    
    constructor(props) {
        super(props);

        bindMethods(
            this, 
            'onPage',
            'onSearch',
        );
    }

    componentDidMount() {

        this.fetchSubtenants()
            .then(
                (subTenants) => {

                    const paging = merge(this.state.paging, { total: subTenants.length });

                    this.setState({
                        subtenants: subTenants,
                        paging,
                    });
                },
            );
    }

    onSearch(query) {
        this.setState({
            query,
        });
    }

    onPage(pageNumber) {

        const paging = merge(this.state.paging, { page: pageNumber });

        this.setState({
            paging,
        });
    }

    fetchSubtenants() {
        return TenantSources.getSubtenants(this.props.authenticationToken, this.props.tenantId);
    }
    
    render() {

        const { subtenants, query, paging: { page, pageSize } } = this.state;
        const pageStart = pageSize * (page - 1);
        const pageEnd = pageStart + pageSize;

        const containsQuery = contains(query.toLowerCase());

        const queriedTenants = subtenants.filter(
            subtenant => !query || containsQuery(subtenant.developerName.toLowerCase()),
        );

        const visibleTenants = queriedTenants.slice(pageStart, pageEnd);

        return (
            <>
                <div className="flex">
                    <button onClick={() => this.props.navigateTo(TENANT_VIEWS.newSubtenant)} className="btn btn-sm btn-success">
                        <span className="glyphicon glyphicon-plus" />
                        {
                            ' New Subtenant'
                        }
                    </button>
                    <SearchInput onSearch={this.onSearch} className="margin-left" />
                </div>
                <Table
                    className="table margin-top"
                    columns={subtenantColumns}
                    items={visibleTenants} 
                />
                <Pager page={page} pageSize={pageSize} total={queriedTenants.length} onPageClick={this.onPage} />
            </>
        );
    }
}

export default SubtenantList;
